import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import flag from '@baseImg/icons/shortcake.webp';

const BG = {
	page: 'AboutCompany',
	brandColor: 'color-brand-orange-400',
	title: 'За Superhosting',
	list:
	  [
		  'Superhosting е част от team.blue и подкрепяме всеки, който развива своя бизнес онлайн.',
		  'Предлагаме цялостни хостинг решения, домейни и интуитивни инструменти за създаване на сайт.',
		  'Вярваме, че технологиите трябва да улесняват бизнеса. Затова създаваме решения, които помагат на клиентите ни да се фокусират върху своя успех.'
	  ],
	additionalText: '',
	priceServiceId: '',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	infoBar: {
		//text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Ставаме на 21 и растем заедно с AI! Създай своя нов сайт с до 78% отстъпка до 29 октомври!',
		buttonText: 'Поръчай',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		//layout: 'color-brand-orange-400'
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'AboutCompany',
	brandColor: 'color-brand-orange-400',
	title: 'About Superhosting',
	list:
	  [
		  'SuperHosting, by team.blue, helps businesses grow their online presence.',
		  'We deliver comprehensive hosting solutions, domains, and intuitive website-building tools - backed by the strength of a leading European digital partner.',
		  'We believe technology should empower, not intimidate, so our customers can focus on building their success.'
	  ],
	additionalText: '',
	priceServiceId: '',
	priceTerm: 12,
	showMonthly: true,
	textColor: 'white',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	infoBar: {
		//text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> We\'re turning 21 and growing together with AI! Create your new website with up to 78% off until Oct. 29!',
		buttonText: 'Order',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		//layout: 'color-brand-orange-400'
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];